export default "__VITE_ASSET__e60a901b__"